import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntity  {
    _originalTypeClassName = "zERP.BO.TransactionEntity";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntity.translate = translateService;
}
this.ContactDetails = [];
this.BankAccounts = [];
this.Entity = new Domain.BusinessEntity();
this.Projects = [];
this.Id = null;
this.IsActive = false;
this.Code = null;
this.Firstname = null;
this.Lastname = null;
this.DateEntered = null;
this.LastModified = null;
this.HasBankAccount = false;
this.Notes = null;
this.VATNumber = null;
this.CompanyNumber = null;
this.Website = null;
this.IsBusinessEntity = false;
this.BusinessEntityName = null;
this.FullName = null;
this.DeliveryAddressSameWithInvoice = false;
this.IsCustomer = false;
this.IsSupplier = false;
this.IsEmployee = false;
this.IsCreditor = false;
this.IsDebtor = false;
this.IsTreasury = false;
this.ADT = null;
this.Profession = null;
this.FatherName = null;
this.DOY = null;
this.VATStatus = null;
this.AFMType = null;
this.CustomerCode = null;
this.SupplierCode = null;
this.EmployeeCode = null;
this.CreditorCode = null;
this.DebtorCode = null;
this.TreasuryCode = null;
this.RegistrationNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsActive:any;
Code:any;
Firstname:any;
Lastname:any;
DateEntered:any;
LastModified:any;
HasBankAccount:any;
Notes:any;
VATNumber:any;
CompanyNumber:any;
Website:any;
IsBusinessEntity:any;
BusinessEntityName:any;
FullName:any;
DeliveryAddressSameWithInvoice:any;
IsCustomer:any;
IsSupplier:any;
IsEmployee:any;
IsCreditor:any;
IsDebtor:any;
IsTreasury:any;
ADT:any;
Profession:any;
FatherName:any;
DOY:any;
VATStatus:any;
AFMType:any;
CustomerCode:any;
SupplierCode:any;
EmployeeCode:any;
CreditorCode:any;
DebtorCode:any;
TreasuryCode:any;
RegistrationNumber:any;
InvoiceAddress:any;
BusinessType:any;
ContactDetails:any;
MainContactDetails:any;
BankAccounts:any;
Entity:any;
AccountingConfig:any;
CustomerCategory:any;
SupplierCategory:any;
EmployeeCategory:any;
CreditorCategory:any;
DebtorCategory:any;
LawFirm:any;
Projects:any;
static setInvoiceAddress = ($this, value) => {
var oldValue = $this.InvoiceAddress;
$this.InvoiceAddress = value;
if (value != null) {
}
}
static setBusinessType = ($this, value) => {
var oldValue = $this.BusinessType;
$this.BusinessType = value;
if (value != null) {
}
}
static setContactDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.ContactDetails == null) $this.ContactDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ContactDetails.length > 0) {
                    Domain.TransactionEntity.removeContactDetails($this, $this.ContactDetails[0]);
                }

                Domain.TransactionEntity.addManyContactDetails($this, copyItems);
            }
static addManyContactDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionEntity.addContactDetails($this, items[i]);
                }
            }
static addContactDetails = ($this, item) => {
                if ($this.ContactDetails == null) $this.ContactDetails = [];
                if (item == null || $this.ContactDetails.indexOf(item) > -1) return;
                $this.ContactDetails.push(item);
}
static addRangeContactDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionEntity.addContactDetails($this, item));
            }
static removeContactDetails = ($this, item) => {
                if ($this == null || $this.ContactDetails == null || $this.ContactDetails.indexOf(item) === -1) return;
                var _index = $this.ContactDetails.indexOf(item);
                $this.ContactDetails.splice(_index, 1);
}
static clearContactDetails = ($this) => { $this.ContactDetails = null; }
static setMainContactDetails = ($this, value) => {
var oldValue = $this.MainContactDetails;
$this.MainContactDetails = value;
if (value != null) {
}
}
static setBankAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.BankAccounts == null) $this.BankAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BankAccounts.length > 0) {
                    Domain.TransactionEntity.removeBankAccounts($this, $this.BankAccounts[0]);
                }

                Domain.TransactionEntity.addManyBankAccounts($this, copyItems);
            }
static addManyBankAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionEntity.addBankAccounts($this, items[i]);
                }
            }
static addBankAccounts = ($this, item) => {
                if ($this.BankAccounts == null) $this.BankAccounts = [];
                if (item == null || $this.BankAccounts.indexOf(item) > -1) return;
                $this.BankAccounts.push(item);
if (item.TransactionEntity != $this) {
Domain.BankAccount.setTransactionEntity(item, $this);
}
}
static addRangeBankAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionEntity.addBankAccounts($this, item));
            }
static removeBankAccounts = ($this, item) => {
                if ($this == null || $this.BankAccounts == null || $this.BankAccounts.indexOf(item) === -1) return;
                var _index = $this.BankAccounts.indexOf(item);
                $this.BankAccounts.splice(_index, 1);
item.TransactionEntity = null;
}
static clearBankAccounts = ($this) => { $this.BankAccounts = null; }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setAccountingConfig = ($this, value) => {
var oldValue = $this.AccountingConfig;
$this.AccountingConfig = value;
if (value != null) {
}
}
static setCustomerCategory = ($this, value) => {
var oldValue = $this.CustomerCategory;
$this.CustomerCategory = value;
if (value != null) {
}
}
static setSupplierCategory = ($this, value) => {
var oldValue = $this.SupplierCategory;
$this.SupplierCategory = value;
if (value != null) {
}
}
static setEmployeeCategory = ($this, value) => {
var oldValue = $this.EmployeeCategory;
$this.EmployeeCategory = value;
if (value != null) {
}
}
static setCreditorCategory = ($this, value) => {
var oldValue = $this.CreditorCategory;
$this.CreditorCategory = value;
if (value != null) {
}
}
static setDebtorCategory = ($this, value) => {
var oldValue = $this.DebtorCategory;
$this.DebtorCategory = value;
if (value != null) {
}
}
static setLawFirm = ($this, value) => {
var oldValue = $this.LawFirm;
$this.LawFirm = value;
if (value != null) {
}
}
static setProjects = ($this, items) => {
                if (items == null) items = [];
                if ($this.Projects == null) $this.Projects = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Projects.length > 0) {
                    Domain.TransactionEntity.removeProjects($this, $this.Projects[0]);
                }

                Domain.TransactionEntity.addManyProjects($this, copyItems);
            }
static addManyProjects = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.TransactionEntity.addProjects($this, items[i]);
                }
            }
static addProjects = ($this, item) => {
                if ($this.Projects == null) $this.Projects = [];
                if (item == null || $this.Projects.indexOf(item) > -1) return;
                $this.Projects.push(item);
if (item.TransactionEntityClient != $this) {
Domain.Project.setTransactionEntityClient(item, $this);
}
}
static addRangeProjects = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.TransactionEntity.addProjects($this, item));
            }
static removeProjects = ($this, item) => {
                if ($this == null || $this.Projects == null || $this.Projects.indexOf(item) === -1) return;
                var _index = $this.Projects.indexOf(item);
                $this.Projects.splice(_index, 1);
item.TransactionEntityClient = null;
}
static clearProjects = ($this) => { $this.Projects = null; }

static CheckIfCanBeAppliedOnAccounting(instance: any,avFor: any): any{let tEntyty = Joove.Common.cast(instance, "Domain.TransactionEntity");
if (tEntyty?.IsCustomer && avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsCustomer")) {return true;}else if (tEntyty?.IsSupplier && avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsSupplier")) {return true;}else if (tEntyty?.IsDebtor && avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsDebtor")) {return true;}else if (tEntyty?.IsCreditor && avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsCreditor")) {return true;}else if (tEntyty?.IsTreasury && avFor?.linq?.select((a) => a?.SystemName)?.toArray()?.linq?.contains("IsTreasury")) {return true;}
return false;
}
static GetClassName(): any{return CLMS.Framework.Utilities.ThrowException("StdLib.RuntimeType.Name()").Test;
}
static GetFullName($this: any): any{if ($this?.IsBusinessEntity) {return $this?.BusinessEntityName;}else {return $this?.Firstname + " " + $this?.Lastname;}
}
static WithhelTaxHeader(fromDate: any,toDate: any): any{let Number1 = "0";
let Number2 = Domain.PayrollIntegration.PrepareString("JL10", 8);
let Number3 = Domain.PayrollIntegration.PrepareString(CLMS.Framework.DateTime.ToString(moment().toDate(), "yyyyMMdd"), 8);
let Number4 = Domain.PayrollIntegration.PrepareString(fromDate, 4);
let Number5 = Domain.PayrollIntegration.PrepareString(" ", 127);
let header = Number1 + Number2 + Number3 + Number4 + Number5;
if (CLMS.Framework.Number.NotEqual(() => header.length, () => 148)) {throw Error("Wrong length for: ΕΠΙΚΕΦΑΛΙΔΑ ΑΡΧΕΙΟΥ. Expected: 148. Got: " + Joove.Common.safeNumber(header?.length));}
return header;
}
static WithhelTaxResponsible(entity: any,from: any,to: any): any{let Number1 = "1";
let Number2 = Domain.PayrollIntegration.PrepareString(moment(from).year()?.toString(), 4);
let Number3 = "";
let Number4 = "";
if (entity?.Type?.Code == "0001") {Number3 = Domain.PayrollIntegration.PrepareString(entity?.EFKA_IndividualName + " " + entity?.EFKA_IndividualFatherName, 30);Number4 = "1";}else {Number3 = Domain.PayrollIntegration.PrepareString(entity?.Name, 30);Number4 = "0";}
let Number5 = Domain.PayrollIntegration.PrepareString(entity?.TaxNumber, 9);
let Number6 = Domain.PayrollIntegration.PrepareString(" ", 16);
let Number7 = Domain.PayrollIntegration.PrepareString(entity?.TaxAddress?.City, 10);
let Number8 = Domain.PayrollIntegration.PrepareString(entity?.TaxAddress?.StreetName, 16);
let Number9 = Domain.PayrollIntegration.PrepareString(entity?.TaxAddress?.StreetNumber, 5);
let Number10 = Domain.PayrollIntegration.PrepareString(entity?.TaxAddress?.PostalCode, 5);
let Number11 = Domain.PayrollIntegration.PrepareNumber(CLMS.Framework.DateTime.ToString(from, "MM"), 2, true);
let Number12 = Domain.PayrollIntegration.PrepareString(" ", 49);
let line = Number1 + Number2 + Number3 + Number4 + Number5 + Number6 + Number7 + Number8 + Number9 + Number10 + Number11 + Number12;
if (CLMS.Framework.Number.NotEqual(() => line.length, () => 148)) {throw Error("Wrong length for: ΣΤΟΙΧΕΙΑ ΔΗΛΟΥΝΤΟΣ. Expected: 148. Got: " + Joove.Common.safeNumber(line?.length));}
return line;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}